<div class="selected" *ngIf="selected.length">
  <button type="button" *ngFor="let statement of selected" class="chip" (click)="remove(statement)"
    [disabled]="control.disabled" [title]="text(statement)"
    [attr.aria-label]="('SDS_H_PICKER_REMOVE' | translate:{ code: statement.Code }) + ': ' + text(statement)">
    {{ statement.Code }} <span aria-hidden="true">×</span>
  </button>
</div>
<label class="search-label">
  <span>{{ 'SDS_H_PICKER_SEARCH' | translate }}</span>
  <input #searchInput type="search" class="form-control" [ngModel]="query" [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="search($event)" (focus)="expanded = true" [disabled]="control.disabled"
    [placeholder]="'SDS_H_STATEMENT_SEARCH_PLACEHOLDER' | translate" />
</label>
<p class="hint">{{ 'SDS_H_PICKER_HELP' | translate }}</p>
<p *ngIf="loading" role="status">{{ 'SDS_H_PICKER_LOADING' | translate }}</p>
<div *ngIf="failed" role="alert">
  {{ 'SDS_H_PICKER_ERROR' | translate }}
  <button type="button" class="btn btn-sm btn-outline-primary" (click)="load()">{{ 'SDS_H_PICKER_RETRY' | translate }}</button>
</div>
<ng-container *ngIf="!loading && !failed">
  <button type="button" class="btn btn-sm btn-outline-primary browse" (click)="expanded = !expanded"
    [attr.aria-expanded]="expanded" [disabled]="control.disabled">
    {{ (expanded ? 'SDS_H_PICKER_HIDE' : 'SDS_H_PICKER_BROWSE') | translate:{ count: catalog.length } }}
  </button>
  <div *ngIf="expanded" class="results">
    <p class="result-count" role="status" aria-live="polite">{{ 'SDS_H_PICKER_COUNT' | translate:range }}</p>
    <p *ngIf="!matches.length">{{ 'SDS_H_PICKER_EMPTY' | translate }}</p>
    <p *ngIf="selected.length >= 50" role="status">{{ 'SDS_H_PICKER_LIMIT' | translate }}</p>
    <ul>
      <li *ngFor="let statement of visible">
        <button type="button" class="result" (click)="add(statement)" [disabled]="control.disabled || selected.length >= 50"
          [attr.aria-label]="('SDS_H_PICKER_ADD' | translate:{ code: statement.Code }) + ': ' + text(statement)">
          <strong>{{ statement.Code }}</strong><span>{{ text(statement) }}</span><span aria-hidden="true">+</span>
        </button>
      </li>
    </ul>
    <nav *ngIf="matches.length > pageSize" [attr.aria-label]="'SDS_H_PICKER_PAGES' | translate">
      <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="page === 0" (click)="page = page - 1">{{ 'SDS_H_PICKER_PREVIOUS' | translate }}</button>
      <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="range.end >= matches.length" (click)="page = page + 1">{{ 'SDS_H_PICKER_NEXT' | translate }}</button>
    </nav>
  </div>
</ng-container>
